module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "unique-opened": "",
      "default-active": _vm.$route.path,
      "background-color": "#324157",
      "text-color": "#ffffff",
      "active-text-color": "#409EFF"
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.permission_routers
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bed26ec8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = 299
// module chunks = 25